import React from 'react';
import { gql } from '@apollo/client';
import { Show, SimpleShowLayout, TextField } from 'react-admin';
import TimestampFields from 'components/TimestampFields';

const ProfessionalAssignmentFavoritesShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <TextField label="Professional ID" source="professional_id" />
      <TextField label="Assignment ID" source="assignment_id" />
      <TimestampFields />
    </SimpleShowLayout>
  </Show>
);

ProfessionalAssignmentFavoritesShow.query = gql`
  query GET_ONE($id: Int!) {
    professionalAssignmentFavorite(id: $id) {
      id
      assignment_id
      professional_id
      created_at
      updated_at
    }
  }
`;

export default ProfessionalAssignmentFavoritesShow;
